import is from '@sindresorhus/is';
import { createContext, useContext, useMemo } from 'react';

import { createApplicationFetchers } from './create-application-fetchers';
import { ApplicationContext } from '../../../shared/source/context/context';

import type { ApplicationFetchers } from './create-application-fetchers';
import type { FunctionComponent, PropsWithChildren } from 'react';

export const ApplicationFetchersContext = createContext<ApplicationFetchers | null>(null);

type ProviderProps = PropsWithChildren<{
    readonly applicationFetchers?: ApplicationFetchers;
}>;

export const ApplicationFetchersProvider: FunctionComponent<ProviderProps> = ({ applicationFetchers, children }) => {
    const { cobrainerApiFetcher, translate, validatingCobrainerApiFetcher } = useContext(ApplicationContext);

    const fetchers = useMemo(() => {
        if (is.object(applicationFetchers)) {
            return applicationFetchers;
        }

        return createApplicationFetchers({ cobrainerApiFetcher, translate, validatingCobrainerApiFetcher });
    }, [applicationFetchers, cobrainerApiFetcher, translate, validatingCobrainerApiFetcher]);

    return <ApplicationFetchersContext.Provider value={fetchers}>{children}</ApplicationFetchersContext.Provider>;
};
